var _style, _defs, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreTradeToEarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st33{fill:none;stroke:#fff;stroke-width:3;stroke-miterlimit:10}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000105428921183703868390000013822540138485148350_",
    transform: "rotate(-45.001 50.58 50.156)",
    d: "M7.7 7.3h85.7V93H7.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049900490143017713700000016202405886953203883_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000105428921183703868390000013822540138485148350_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000049900490143017713700000016202405886953203883_)",
      fill: "none",
      stroke: "#fff",
      strokeWidth: 6,
      strokeLinecap: "round"
    },
    d: "M16.3 61.6c0 12.6 10.2 22.9 22.9 22.9h22.9C74.7 84.5 85 74.3 85 61.6V38.7c0-12.6-10.2-22.9-22.9-22.9H39.2c-12.6 0-22.9 10.2-22.9 22.9v22.9z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st33",
    cx: 59.6,
    cy: 40.3,
    r: 8.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st33",
    cx: 42.2,
    cy: 58.5,
    r: 8.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.1 67.2c0 1-2.2 1.8-5 1.8H32.7c-2.8 0-5-.8-5-1.8s2.2-1.8 5-1.8h33.4c2.8 0 5 .8 5 1.8z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1 67.2c0 1-2.2 1.8-5 1.8H32.7c-2.8 0-5-.8-5-1.8s2.2-1.8 5-1.8h33.4c2.8 0 5 .8 5 1.8z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreTradeToEarn);
export default __webpack_public_path__ + "static/media/exploreTradeToEarn.1ea1248e46d82a0a2e089a2966324afb.svg";
export { ForwardRef as ReactComponent };